import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

firebase.initializeApp({
    apiKey: 'AIzaSyDwNGtjThiUCRsQor1Vxo1b6zes4Z0kYV4',
    authDomain: 'picker-staging.firebaseapp.com',
    databaseURL: 'https://picker-staging.firebaseio.com',
    projectId: 'picker-staging',
    storageBucket: 'picker-staging.appspot.com',
    messagingSenderId: '487986858717'
}, 'staging');

firebase.initializeApp({
    apiKey: 'AIzaSyCNH0l4-Q1nHjOnGkO-ak04Bu1o8NgFr-0',
    authDomain: 'picker-live.firebaseapp.com',
    databaseURL: 'https://picker-live.firebaseio.com',
    projectId: 'picker-live',
    storageBucket: 'picker-live.appspot.com',
    messagingSenderId: '853646187928'
}, 'live');

firebase.initializeApp({
    apiKey: "AIzaSyB6Yt2-dybsnbLP-nk7Z0b8q_FIlzBheG8",
    authDomain: "picker-devops.firebaseapp.com",
    databaseURL: "https://picker-devops.firebaseio.com",
    projectId: "picker-devops",
    storageBucket: "picker-devops.appspot.com",
    messagingSenderId: "823382240052",
}, 'devops');

Promise.all([
    waitForFirebaseInit('staging'),
    waitForFirebaseInit('live'),
    waitForFirebaseInit('devops')
]).then(() => {
    const db = firebase.app('devops').firestore();
    db.settings({
        timestampsInSnapshots: true
    });
    ReactDOM.render(<App/>, document.getElementById('root'));
});

function waitForFirebaseInit(appName) {
    return new Promise((resolve) => {
        const unsub = firebase.app(appName).auth().onAuthStateChanged(() => {
            unsub();
            resolve();
        });
    });
}



// WEBPACK FOOTER //
// ./src/index.js